import { gql } from '@apollo/client'
import { format } from 'date-fns'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'

import { MOONBEAM } from '../../config/chains'
import { SUBGRAPH_URLS } from '../../config/subgraphs'
import { MOONBEAM_TOKENS, MOONBEAM_TOKEN_NAMES, USD_DECIMALS } from '../const'
import { roundDownToNearestDay } from '../numbers'
import { createClient } from '../useClient'

export default function useTokenStats(params) {
  const [tokenStats, setTokenStats] = useState([])
  const client = createClient(SUBGRAPH_URLS[MOONBEAM].stats)

  useEffect(() => {
    if (!params.fromValue || !params.toValue) {
      return
    }

    const start = roundDownToNearestDay(params.fromValue)
    const end = roundDownToNearestDay(params.toValue)

    const tokenStatsQuery = gql`
      query dailyTokenStats($start: Int!, $end: Int!, $token: Bytes!) {
        tokenStats(
          first: 1000
          orderBy: timestamp
          orderDirection: asc
          where: {
            period: daily
            timestamp_gt: $start
            timestamp_lt: $end
            token: $token
          }
        ) {
          timestamp
          token
          poolAmountUsd
        }
      }
    `

    const getTokenStats = async () => {
      const promises = MOONBEAM_TOKENS.map((tokenAddress) =>
        client
          .query({
            query: tokenStatsQuery,
            variables: { start: start, end: end, token: tokenAddress },
          })
          .then(({ data }) => {
            return data.tokenStats.map((el) => {
              return {
                timestamp: el.timestamp,
                date: new Date(el.timestamp * 1000),
                [MOONBEAM_TOKEN_NAMES[tokenAddress]]: parseFloat(
                  ethers.utils.formatUnits(el.poolAmountUsd, USD_DECIMALS)
                ),
              }
            })
          })
      )

      Promise.all(promises).then((results) => {
        const mergedResults = [].concat(...results)
        mergedResults.sort((a, b) => a.timestamp - b.timestamp)

        mergedResults.forEach((result) => {
          result.timestamp = format(result.date, 'do MMM yyyy')
        })

        let tokenStats = []
        mergedResults.forEach((result) => {
          const index = tokenStats.findIndex(
            (item) => item.timestamp === result.timestamp
          )
          if (index === -1) {
            tokenStats.push(result)
          } else {
            tokenStats[index] = { ...tokenStats[index], ...result }
          }
        })

        setTokenStats(tokenStats)
      })
    }

    getTokenStats()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  return tokenStats
}
